import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconClose } from "./icons";
import { Checkbox } from "@lib/components";
import { MenuItem, QuickSettingsContainer, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorBodyWrapper, MenuColorLabel, MenuColorFooterWrapper, MenuActionContainer, MenuActionItem, ButtonV2 } from "./layout.c";
import { POS_PRINTERS } from "./data";

interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave?: (selectedPrinterValues: number[]) => void;
    title?: string;
    /** Current item's printer assignments (POS printer values 1-8) */
    selectedPrinterValues?: number[];
}

interface State {
    selected: number[];
}

@inject("store") @observer
class MenuPrinterAssignItemsClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selected: props.selectedPrinterValues ?? []
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.show && this.props.selectedPrinterValues !== prevProps.selectedPrinterValues) {
            this.setState({ selected: this.props.selectedPrinterValues ?? [] });
        }
    }

    togglePrinter(value: number) {
        this.setState((s) => ({
            selected: s.selected.includes(value) ? s.selected.filter((v) => v !== value) : [...s.selected, value]
        }));
    }

    render() {
        const { show, onHide, onSave, title } = this.props;
        const { selected } = this.state;

        return (
            <QuickSettingsContainer className={show ? 'active' : ''}>
                <MenuColorHeaderWrapper>
                    <MenuColorHeaderTitleWrapper>
                        {title || 'Assign printer for this item'}
                    </MenuColorHeaderTitleWrapper>
                    <MenuItem onClick={onHide}><IconClose /></MenuItem>
                </MenuColorHeaderWrapper>
                <MenuColorBodyWrapper style={{ minHeight: '50vh', overflowY: 'scroll' }}>
                    <MenuColorLabel>Assign printer for this item</MenuColorLabel>
                    <MenuActionContainer>
                        {POS_PRINTERS.map((printer) => {
                            const checked = selected.includes(printer.value);
                            return (
                                <MenuActionItem
                                    key={printer.value}
                                    onClick={() => this.togglePrinter(printer.value)}
                                    className="menu-printer-item"
                                >
                                    <div className='printer-checkbox'>
                                        <Checkbox
                                            id={`printer-${printer.value}`}
                                            checked={checked}
                                            onChange={() => this.togglePrinter(printer.value)}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                        {printer.label}
                                    </div>
                                </MenuActionItem>
                            );
                        })}
                    </MenuActionContainer>
                </MenuColorBodyWrapper>
                <MenuColorFooterWrapper>
                    <ButtonV2 variant="default" onClick={onHide}>Cancel</ButtonV2>
                    <ButtonV2 onClick={() => onSave?.(selected)}>Save</ButtonV2>
                </MenuColorFooterWrapper>
            </QuickSettingsContainer>
        );
    }
}
export const MenuPrinterAssignItems = withTranslation()(MenuPrinterAssignItemsClass);
